import { render, staticRenderFns } from "./Structure.vue?vue&type=template&id=2984dcd8&scoped=true"
import script from "./Structure.vue?vue&type=script&lang=js"
export * from "./Structure.vue?vue&type=script&lang=js"
import style0 from "./Structure.vue?vue&type=style&index=0&id=2984dcd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_css-loader@6.11.0_webpack@5.107.2_postcss@8_304b4a1ebea3bd82ec282759e0696211/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2984dcd8",
  null
  
)

export default component.exports